module.exports = __webpack_public_path__ + "img/02-326x184-pozmanter.d516b54b.jpg";